import React, { Children, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
// import JS files

// import others files
import MuiDrawer from "../mui/MuiDrawer";
import TemplateNavbar from "./TemplateNavbar";

const Template = ({ children, sidebarActiveLink }) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };
  return (
    <>
      <div className="grid md:grid-cols-12 h-screen">
        {/* Desktop Navbar */}
        <div className="hidden md:block  md:col-span-2">
          <TemplateNavbar sidebarActiveLink={sidebarActiveLink} />
        </div>
        {/* Mobile Navbar */}
        <div className=" md:hidden bg-mygreen-100 shadow fixed w-screen z-1 py-3 px-3 flex justify-between items-center">
          <MenuIcon
            fontSize="large"
            className="text-white font-bold"
            onClick={() => toggleDrawer()}
          />
          <span className="font-bold text-white text-lg">سامانه ثبت نام تکمیلی درمان</span>
        </div>
        <div className="col-span-10 p-4 md:p-8">{children}</div>
      </div>
      <MuiDrawer
        anchor="right"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        <TemplateNavbar mobileToggleDrawer={toggleDrawer} sidebarActiveLink={sidebarActiveLink} />
      </MuiDrawer>
    </>
  );
};

export default Template;
